import React from "react"
import { Navigate } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
//Ecs Courier Info
import CourierInfo from "pages/EcsCourierInfo/sendCourier"
//All Courier
import AllCourierDetail from "pages/EcsCourierInfo/allCourier"
//Courier Categories
import CourierDetailCategories from "pages/EcsCourierInfo/couriescategories"
//View Courier
import CourierDetail from "pages/EcsCourierInfo/viewdetail"
//Edit Courier
import EditCourierInfo from "pages/EcsCourierInfo/editcourier"
//Track Parcel
import Trackcourier from "pages/EcsCourierInfo/Trackcourier"
//Ecs Users
import EcsUsers from "pages/EcsUsers/Ecsusers"
import AppUsers from "pages/EcsUsers/AppUsers"
//Service Categoris
import AllServicesDetail from "pages/Ecs Setting/Allservices"
//Service Categoris Add
import AddServicesCharges from "pages/Ecs Setting/addservices"
//Employee All
import AllEmployeeDetail from "pages/Ecs Setting/AllEmployee"
//ECS Controls
import EcsControls from "pages/Ecs Setting/controls"
import AllRequestsDetail from "pages/EcsCourierInfo/allRequests"
import TodayCourierDetail from "pages/EcsCourierInfo/todayCourier"
import SendByRequest from "pages/EcsCourierInfo/sendByRequest"
import RiderManagement from "pages/RiderManagement/ManageRider"
import BusinessManagement from "pages/BusinessManagement/BusinessManagement"
import RiderWallet from "pages/RiderManagement/RiderWallet"
import BusinessServiceTypes from "pages/BusinessCharges/BusinessServiceTypes"
import BusinessChargesControll from "pages/BusinessCharges/BusinessCalculator"
import AllBusinessCodLeads from "pages/BusinessManagement/BusinessLeads"
import ApprovedBusiness from "pages/BusinessManagement/ApprovedBusiness"
import BusinessRateCard from "pages/BusinessManagement/BusinessRateCard"
import ProcessLeadPage from "pages/BusinessManagement/ProcessCodLead"
import PrintCodLead from "pages/BusinessManagement/PrintSubmitCodLead"
import BusinessWallet from "pages/BusinessManagement/BusinessWallet"
import PrintBusinessWallet from "pages/BusinessManagement/PrintBusinessWallet"
import ZoneManager from "pages/Ecs Setting/ZoneManager"
import InternationalCarries from "pages/International/IntCarriers"
import ZonesForCarrier from "pages/International/intZones"
import RatesForCarrier from "pages/International/IntRates"
import InternationalBooking from "pages/International/IntBooking"

//Contact Leads
import AllContactLeads from "pages/ContactLeads/allLeads"
import NewContactLeads from "pages/ContactLeads/newLeads"
import PendingContactLeads from "pages/ContactLeads/pendingLeads"
import ActiveContactLeads from "pages/ContactLeads/activeLeads"
import LeadsSettings from "pages/ContactLeads/setting"
import AllInternationalBookings from "pages/International/AllIntBookings"
import AllIntConsignees from "pages/International/IntConsignee"

const authProtectedRoutes = [
  //Contact Leads
  { path: "/all-contact-leads", component: <AllContactLeads /> },
  { path: "/new-contact-leads", component: <NewContactLeads /> },
  { path: "/pending-contact-leads", component: <PendingContactLeads /> },
  { path: "/active-contact-leads", component: <ActiveContactLeads /> },
  { path: "/leads-setting", component: <LeadsSettings /> },

  //Ecs Courier Info
  { path: "/courier_info", component: <CourierInfo /> },
  //Ecs all Courier
  { path: "/all_parcel_detail/", component: <AllCourierDetail /> },
  //Ecs Today Courier
  { path: "/today_book/", component: <TodayCourierDetail /> },
  //Ecs All Requests
  { path: "/all_requests/", component: <AllRequestsDetail /> },
  //Ecs all Courier Categories
  { path: "/parcel_detail/:id", component: <CourierDetailCategories /> },
  //View Courier
  { path: "/view/courier_detail/:id", component: <CourierDetail /> },
  //Edit Courier
  { path: "/edit_courier_detail/:id", component: <EditCourierInfo /> },
  //Track Parcel
  { path: "/track_/:id", component: <Trackcourier /> },
  //Ecs Users
  { path: "/users", component: <EcsUsers /> },
  { path: "/app-users", component: <AppUsers /> },
  //Rider Management
  { path: "/rider-management", component: <RiderManagement /> },
  { path: "/rider-wallet", component: <RiderWallet /> },
  { path: "/rider-wallet/:rider_id", component: <RiderWallet /> },

  //Business Management
  { path: "/request-businesses", component: <BusinessManagement /> },
  { path: "/approved-business", component: <ApprovedBusiness /> },
  { path: "/cod-leads", component: <AllBusinessCodLeads /> },
  {
    path: "/cod-businesses/:businessId/rates",
    component: <BusinessRateCard />,
  },
  { path: "/process_cod/:id", component: <ProcessLeadPage /> },
  { path: "/leads/:id/print", component: <PrintCodLead /> },
  { path: "/cod-business/wallet", component: <BusinessWallet /> },
  { path: "/cod-business/wallet/:id", component: <BusinessWallet /> },

  //Business Charges Control
  { path: "/cod-service-type", component: <BusinessServiceTypes /> },
  {
    path: "/cod-service-charges",
    component: <BusinessChargesControll />,
  },

  //All Services Categories
  { path: "/services_categories", component: <AllServicesDetail /> },
  //Add Services Categories
  { path: "/services_categories/add", component: <AddServicesCharges /> },
  //All Employee
  { path: "/employee_detail", component: <AllEmployeeDetail /> },
  //Ecs Controls
  { path: "/controls", component: <EcsControls /> },
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/manage-zone", component: <ZoneManager /> },

  //Requst to Final
  { path: "/send_courier/:id", component: <SendByRequest /> },

  //profile
  { path: "/profile", component: <UserProfile /> },

  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },

  //International
  { path: "/int-carriers", component: <InternationalCarries /> },
  { path: "/carriers/:carrierId/zones", component: <ZonesForCarrier /> },
  { path: "/carriers/:carrierId/rates", component: <RatesForCarrier /> },
  { path: "/int-booking", component: <InternationalBooking /> },
  { path: "/int-bookings", component: <AllInternationalBookings /> },
  { path: "/int-consignees", component: <AllIntConsignees /> },
]

const publicRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
]

export { authProtectedRoutes, publicRoutes }
